class DetailsModal extends HTMLElement {
  constructor() {
    super();
    this.querySelector('summary')?.addEventListener('click', (event) => {
      event.preventDefault();
      this.querySelector('details')?.setAttribute('open', '');
    });
    this.querySelectorAll('[type="button"], .modal__close-button').forEach((button) => {
      button.addEventListener('click', () => this.querySelector('details')?.removeAttribute('open'));
    });
  }
}

if (!customElements.get('details-modal')) {
  customElements.define('details-modal', DetailsModal);
}
